
import { useNavigate } from 'react-router-dom';
import { useTonConnectUI } from '@tonconnect/ui-react';
import { Address, beginCell, toNano } from '@ton/core';
import BackButton from './BackButton';
import TonWeb from 'tonweb';
import './WalletPage.css';
import React, { useState, useEffect } from 'react';
import { HttpClient, TonClient } from "@ton/ton";
import { Cell } from '@ton/core';
import axios from 'axios';

const apiKey = 'af367eea985bd0df59ae17d9aa218a1af12ede3bdf4755f4188f7582f5fb3859'; //ключ с бота тг

const client = new TonClient({ endpoint: 'https://toncenter.com/api/v2/jsonRPC', apiKey });
async function getUserJettonWalletAddress(userAddress, jettonMasterAddress) {
const userAddressCell = beginCell().storeAddress(Address.parse(userAddress)).endCell();

const response = await client.runMethod(Address.parse(jettonMasterAddress), 'get_wallet_address', [
    { type: 'slice', cell: userAddressCell },
  ]);

  return response.stack.readAddress();
}
function httpGetAsync(theUrl, callback)
{
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function() { 
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
            callback(xmlHttp.responseText);
    }
    xmlHttp.open("GET", theUrl, true); // true for asynchronous 
    xmlHttp.send(null);
}
var address = "";
const Tonkeeper = Address.parse("kQAiboDEv_qRrcEdrYdwbVLNOXBHwShFbtKGbQVJ2OKxY_Di");
const userJettonWallet = Address.parse('UQDuA-JcvgtDxWVZt0XuU5xZ8AS_-qu2aiMzT3hUR2zgO-Eg');
const jettonMasterAddress = Address.parse('kQAiboDEv_qRrcEdrYdwbVLNOXBHwShFbtKGbQVJ2OKxY_Di');
const toAddress = Address.parse('UQD2KDv1Ggp2cFg6TOBb1LKm22HMu9bSptKDH5WWEKBimC9n');
const fromAddress = Address.parse('UQCLEJm1wQAvZ8oQJNSPEcxeVm04cscV0MEyBvqHZhTWxfO8');
const ContractjettonWalletAddress = Address.parse('kQCShRY-v3ciLAgbXEuxXpdb185u8Hgq0D8Svgq_Krxl4Ajn');
const jettonAmount = '1000000'; // например 10 AIOTX (с учётом 9 знаков)
const forwardPayload2= beginCell()
        .storeUint(1241351, 64) // 0 opcode means we have a comment
        .endCell();



        
const payload = beginCell()
  .storeUint(0xf8a7ea5, 32)   // op
  .storeUint(0, 64)          // query_id
  .storeCoins(toNano("1") ) // jetton amount, amount * 10^9
  .storeAddress(fromAddress) // jetton address
  .storeAddress(toAddress) // response destination
  .storeUint(0, 1)             // query_id
  .storeCoins(toNano("0.05")) // forward_ton_amount
  .storeUint(0, 1)  
  //.storeRef(forwardPayload)
  .endCell();



const WalletPage = () => {
  const navigate = useNavigate();                 
  const [tonConnectUI] = useTonConnectUI();        
/**
 * Ensure that the user is connected to the wallet. If not, open a modal to
 * connect the wallet. After the wallet is connected, update the address
 * variable with the wallet's address.
 */
  const ensureConnected = async () => {
  if (!tonConnectUI.wallet) {
    await tonConnectUI.openModal(); // Откроет окно подключения кошелька
    
    
  }
  address = Address.parse(tonConnectUI.wallet.account.address);
};
  const handlePayment = async () => {
  try {
    await ensureConnected();

    
    //const jettonWalletAddress = await getUserJettonWalletAddress(address, jettonMasterAddress);
    const transaction = {
      validUntil: Math.floor(Date.now() / 1000) + 300,
      messages: [
        {
          address: userJettonWallet.toString(true, true, true), // 👈 отправляем на него!
          amount: toNano('0.001').toString(),
          payload: beginCell()
                      .storeUint(1, 32) // 0 opcode means we have a comment
                      .storeUint(0, 64)
                      .storeUint(jettonAmount, 32)
                      .storeAddress(address)
                      .storeRef(forwardPayload2)
                      .endCell().toBoc().toString('base64'),
          bounce: false
        },
      ],
    };

    const transactionPay = {
      validUntil: Math.floor(Date.now() / 1000) + 300,
      messages: [
        {
          address: toAddress.toString(true, true, true), // 👈 отправляем на него!
          amount: toNano('0.06').toString(),
          payload: forwardPayload2.toBoc().toString('base64'),
        },
      ],
    };
    const result = await tonConnectUI.sendTransaction(transaction);
    const bocCellBytes = await TonWeb.boc.Cell.oneFromBoc(TonWeb.utils.base64ToBytes(result.boc)).hash();

    const rawSender = `${fromAddress.workChain}:${Buffer.from(fromAddress.hash).toString('hex')}`;
    const rawRecipient = `${userJettonWallet.workChain}:${Buffer.from(userJettonWallet.hash).toString('hex')}`;
    const hashHex = TonWeb.utils.bytesToHex(bocCellBytes);
    const apiUrl = `http://localhost:15276/ton/transaction/${rawSender}/${rawRecipient}/${hashHex}`;

    console.log('🔗 Проверяю транзакцию:', apiUrl);

    const resultcheck = await fetch(apiUrl)
    .then(res => res.json())
    .then(data => {
      console.log('Transaction status:', data);
    })
    .catch(err => console.error(err));
    console.log('Signed BOC:', resultcheck);
    navigate('/success');
  } catch (error) {
    console.error('Ошибка при отправке транзакции:', error);
  }
};
  

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="container">
      {loading ? (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
      ) : (
    <div className="wallet-page">
      <button onClick={handlePayment} className="pay-button">
        Оплатить
      </button>
      <BackButton onClick={() => navigate('/fork')} />
    </div>
    )}
    </div>
  );
};

export default WalletPage;